import type React from "react";

import type { FragmentType } from "~/utils/fragment";

import { PackCard } from "../PackCard";
import type { PackGrid_PackFragment } from "./PackGrid_PackFragment";

export const PackGrid: React.FC<{
  packs: FragmentType<"Pack", { select: typeof PackGrid_PackFragment }>[];
}> = ({ packs }) => {
  return (
    <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {packs.map((pack) => (
        <PackCard
          key={pack.id}
          pack={pack}
          packActions={{
            omit: ["delete"],
          }}
        />
      ))}
    </div>
  );
};
